// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1KTCH","clinicsSelect":"TableHeading_clinicsSelect__31KGV"};